import { render } from "./newrequest.vue?vue&type=template&id=780f95bf"
import script from "./newrequest.vue?vue&type=script&lang=js"
export * from "./newrequest.vue?vue&type=script&lang=js"

import "./newrequest.vue?vue&type=style&index=0&id=780f95bf&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__